import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiServices } from "../4.Utils/apiServices";
import moment from "moment/moment";

const namespace = "leaveprorates";

//List of Leave Awards by Year + Pagination
export const getLeaveProratesListByYear = createAsyncThunk(
    `${namespace}/lists`,
    async (body, { rejectWithValue }) => {
      const api = "get_leave_prorates_year";
      const replace = {
        search: "{year}",
        replace: body.year,
      };
      const opt = {
        replace: replace,
        body: body,
      };
  
      try {
        const response = await apiServices(api, opt);
        return response.data;
      } catch (err) {
        return rejectWithValue(err);
      }
    }
);

//Update Leave Award Detail
export const updateLeaveProrates = createAsyncThunk(
    `${namespace}/update`,
    async (body, { rejectWithValue }) => {
      const api = "update_leave_prorates";
      const replace = {
        search: "{id}",
        replace: body.id,
      };
      const opt = {
        replace: replace,
        body: body,
      };
  
      try {
        const response = await apiServices(api, opt);
        return response.data;
      } catch (err) {
        return rejectWithValue(err);
      }
    }
);

//Get Awards Lists
export const getALeaveProrates = createAsyncThunk(
    `${namespace}/get`,
    async (body, { rejectWithValue }) => {
      const api = "list_a_leave_prorates";
      const replace = {
        search: "{id}",
        replace: body.id,
      };
      const opt = {
        replace: replace,
        body: body,
      };
  
      try {
        const response = await apiServices(api, opt);
        return response.data;
      } catch (err) {
        return rejectWithValue(err);
      }
    }
);

//Get Awards Lists
export const getALeaveProratesByID = createAsyncThunk(
  `${namespace}/get/ID`,
  async (body, { rejectWithValue }) => {
    const api = "get_a_leave_prorates";
    const opt = {
      replace: [
        { search: "{employeeId}", replace: body.id },
        { search: "{year}", replace: body.year },
        { search: "{type}", replace: body.type },
      ],
    };

    try {
      const response = await apiServices(api, opt);
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

const initialState = {
    search: {
      searchText : "",
      choice: 1, //employee name
    },
    proratesList: {
        id: "",
        prorate_date : moment(new Date()).format("YYYY-MM-DD"),
        year : new Date().getFullYear(),
        leave_bf : 0,
        leave_awarded_this_year : 0,
        sickleave_awarded_this_year : 0,
        medicalbenefit_awarded_this_year : 0,
        leave_taken_this_year : 0,
        current_leave_balance : 0,
        prorated_pct_first_year : 0,
        prorated_pct_final_year : 0,
        prorated_leave_awarded : 0,
        prorated_sickleave_awarded : 0,
        prorated_medicalbenefit_awarded : 0,
        new_leave_balance : 0,
        deduction_required : 0,
        employee_id : "",
        created : 0,
        createdby : 0,
        status : 0,
        modified : 0,
        modifiedby : 0,
        prorate_type : 1
    },
    entitle: {
      sick_entitle: 0,
      annual_entitle: 0,
      medical_entitle: 0
    },
    loading: false,
    error: false,
    currentPage: 1,
    currentPageCount: 0,
    proratesLists: [],
}

const LeaveProratedSlice = createSlice({
    name: namespace,
    initialState,
    reducers: {
        // update entity
        updateSearch(state, action) {
            state.search = action.payload;
        },

        // update entity
        updateList(state, action) {
            return { ...state, proratesList: action.payload };
        },

        updateEntitle(state, action) {
          return { ...state, entitle: action.payload };
        },

        resetList(state) {
            return {
              ...state,
              proratesList: initialState.proratesList,
              entitle: initialState.entitle,
            };
        },
    },
    extraReducers: (builder) => {
        builder
        .addCase(getLeaveProratesListByYear.pending, (state) => {
            state.loading = true;
            state.error = false;
        })
        .addCase(getLeaveProratesListByYear.fulfilled, (state, action) => {
            state.loading = false;
            state.proratesLists = action.payload;
        })
        .addCase(getLeaveProratesListByYear.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })

        //get a leave awards
        .addCase(getALeaveProrates.pending, (state) => {
            state.loading = true;
            state.error = false;
        })
        .addCase(getALeaveProrates.fulfilled, (state, action) => {
            state.loading = false;
            state.proratesList = action.payload;
        })
        .addCase(getALeaveProrates.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })

        //get a leave awards by id, type and year
        .addCase(getALeaveProratesByID.pending, (state) => {
            state.loading = true;
            state.error = false;
        })
        .addCase(getALeaveProratesByID.fulfilled, (state, action) => {
            state.loading = false;
            state.proratesList = action.payload;
        })
        .addCase(getALeaveProratesByID.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })

        //put
        .addCase(updateLeaveProrates.pending, (state, action) => {
            state.loading = true;
        })
        .addCase(updateLeaveProrates.fulfilled, (state, action) => {
            state.loading = false;
        })
        .addCase(updateLeaveProrates.rejected, (state, action) => {
            state.error = true;
            state.loading = false;
            console.error(action.payload);
        })
    }
});

export const { resetList, updateList, updateSearch, updateEntitle } = LeaveProratedSlice.actions;

export default LeaveProratedSlice.reducer;